import React, { Component } from "react";

class Graphs extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        return <p>Not yet implemented</p>;
    }
}

export default Graphs;



// WEBPACK FOOTER //
// ./src/container/graphs/Graphs.js